import { render } from "./FPluginList.vue?vue&type=template&id=72d52b6a"
import script from "./FPluginList.vue?vue&type=script&lang=js"
export * from "./FPluginList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__